// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.properties.CustomerAnalyticsMoodysWebApiHandler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CustomerAnalyticsAvailableCreditDetailsDto,
  CustomerAnalyticsGetPremiumMoodysReportRequestDto,
  CustomerAnalyticsMoodysCreditOverviewDto,
  CustomerAnalyticsMoodysMarketDto,
  CustomerAnalyticsMoodysReportDto,
  CustomerAnalyticsMoodysShapeDto,
  ListingAlias,
} from '../..';

interface DoesMoodysDownloadRequireCreditParams {
  metroId: string;
  quarter: number;
  submarketId?: number;
  year: number;
}
interface GetMoodysGeometryParams {
  metroId: string;
  submarketId?: number;
}
interface GetMoodysReportParams {
  listingAlias: ListingAlias;
}

export const CustomerAnalyticsMoodysWebApiHandler_canUserDownloadPremiumReport_Path =
  '/api/web/v1/users/moodys/canUserDownloadPremiumReport';

/**
 * Check if user can download a premium report
 */
export const CustomerAnalyticsMoodysWebApiHandler_canUserDownloadPremiumReport = (client = getClient()) => {
  return httpApiRequest<never, never, boolean>(
    {
      endpoint: CustomerAnalyticsMoodysWebApiHandler_canUserDownloadPremiumReport_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsMoodysWebApiHandler_doesMoodysDownloadRequireCredit_Path =
  '/api/web/v1/users/moodys/doesMoodysDownloadRequireCredit';

/**
 * Check if download requires credit
 */
export const CustomerAnalyticsMoodysWebApiHandler_doesMoodysDownloadRequireCredit = (
  getParams: DoesMoodysDownloadRequireCreditParams,
  client = getClient(),
) => {
  return httpApiRequest<DoesMoodysDownloadRequireCreditParams, never, boolean>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsMoodysWebApiHandler_doesMoodysDownloadRequireCredit_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsMoodysWebApiHandler_getAvailableMoodysCreditDetails_Path =
  '/api/web/v1/users/moodys/getAvailableMoodysCreditDetails';

/**
 * Get moodys available credit details
 */
export const CustomerAnalyticsMoodysWebApiHandler_getAvailableMoodysCreditDetails = (client = getClient()) => {
  return httpApiRequest<never, never, Array<CustomerAnalyticsAvailableCreditDetailsDto>>(
    {
      endpoint: CustomerAnalyticsMoodysWebApiHandler_getAvailableMoodysCreditDetails_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsMoodysWebApiHandler_getMoodysCreditOverview_Path =
  '/api/web/v1/users/moodys/getMoodysCreditOverview';

/**
 * Get moodys credit overview
 */
export const CustomerAnalyticsMoodysWebApiHandler_getMoodysCreditOverview = (client = getClient()) => {
  return httpApiRequest<never, never, CustomerAnalyticsMoodysCreditOverviewDto>(
    {
      endpoint: CustomerAnalyticsMoodysWebApiHandler_getMoodysCreditOverview_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsMoodysWebApiHandler_getMoodysGeometry_Path = '/api/web/v1/users/moodys/getMoodysGeometry';

/**
 * Get moodys geometry
 */
export const CustomerAnalyticsMoodysWebApiHandler_getMoodysGeometry = (
  getParams: GetMoodysGeometryParams,
  client = getClient(),
) => {
  return httpApiRequest<GetMoodysGeometryParams, never, Array<CustomerAnalyticsMoodysShapeDto>>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsMoodysWebApiHandler_getMoodysGeometry_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsMoodysWebApiHandler_getMoodysMarkets_Path = '/api/web/v1/users/moodys/getMoodysMarkets';

/**
 * Get moodys markets
 */
export const CustomerAnalyticsMoodysWebApiHandler_getMoodysMarkets = (client = getClient()) => {
  return httpApiRequest<never, never, Array<CustomerAnalyticsMoodysMarketDto>>(
    {
      endpoint: CustomerAnalyticsMoodysWebApiHandler_getMoodysMarkets_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsMoodysWebApiHandler_getMoodysReport_Path = '/api/web/v1/users/moodys/getMoodysReport';

/**
 * Get basic moodys report for listing
 */
export const CustomerAnalyticsMoodysWebApiHandler_getMoodysReport = (
  getParams: GetMoodysReportParams,
  client = getClient(),
) => {
  return httpApiRequest<GetMoodysReportParams, never, CustomerAnalyticsMoodysReportDto>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsMoodysWebApiHandler_getMoodysReport_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsMoodysWebApiHandler_getPremiumMoodysReport_Path =
  '/api/web/v1/users/moodys/getPremiumMoodysReport';

/**
 * Get moodys premium report
 */
export const CustomerAnalyticsMoodysWebApiHandler_getPremiumMoodysReport = (
  postData: CustomerAnalyticsGetPremiumMoodysReportRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, CustomerAnalyticsGetPremiumMoodysReportRequestDto, CustomerAnalyticsMoodysReportDto>(
    {
      endpoint: CustomerAnalyticsMoodysWebApiHandler_getPremiumMoodysReport_Path,
      method: 'POST',
      contextPath: '/customer-analytics',
      postData: postData,
      unwrapApiLayerResponse: true,
    },
    client,
  );
};
